<div class="custom-header"></div>
<template id="form_section">
  <div class="franchise-wrapper">
    <!-- New Design -->
    <section
      class="container-fluid pb-xl-5 mb-5 gradient-box bg-primary-gradient"
      style="border-radius: 0px; display: block"
    >
      <div class="row align-items-start justify-content-center">
        <div class="col-lg-6 custom_overflow">
          <!-- custom_background_image -->
          <h3
            class="main-heading-1-normal"
            data-aos="fade-right"
            data-aos-duration="600"
          >
            Welcome To The {{ OfficeName }} Office
          </h3>
          <h3
            class="main-heading-1-normal pt-2"
            data-aos="fade-left"
            data-aos-duration="600"
          >
            {{ OfficeNameAlternateLang }}
          </h3>
          <!-- <p class="main-content-1 pt-1 fontWeightCustom">
            Applying to the Aliff Than Office is a breeze - just fill in the
            necessary details and submit the form! Below, you'll find helpful
            information to determine if this office is right fit for you. Don't
            worry about scrolling all the way back up, there's a button at the
            end that takes you straight to the form!
          </p> -->
          <p class="main-content-1 pt-1 w-75 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/Poniter_new.svg" />
            {{ OfficeAddress }}
          </p>

          <p class="main-content-1 pt-1 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/Phone_new.svg" />
            <a :href="'tel:' + OfficePhone" style="color: #fff">{{
              OfficePhone
            }}</a>
          </p>

          <p class="main-content-1 pt-1 fontWeightCustom mb-0">
            <img src="@/assets/imgs/franchise/email_2099199_new.svg" />
            <a :href="'mailto:' + OfficeEmail" style="color: #fff">{{
              OfficeEmail
            }}</a>
          </p>
          <!-- <div class="text-right city_img">
            <img src="@/assets/imgs/city.png" alt="" />
          </div> -->
        </div>
        <div
          class="col-lg-6 form_wrapper responsive_margin"
          data-aos="fade-up"
          data-aos-duration="600"
          style="border-radius: 10px"
        >
          <form @submit.prevent="handleSubmit" v-if="!agent">
            <div class="custom-form-control">
              <div class="form-spacing">
                <label>Name:</label>
                <input
                  size="sm"
                  required
                  v-model="form.name"
                  placeholder="Enter Name *"
                  class="form-control"
                />
              </div>

              <div class="form-spacing">
                <label>Email:</label>
                <input
                  required
                  size="sm"
                  v-model="form.email"
                  placeholder="Enter Email Address *"
                  class="form-control"
                />
              </div>

              <div class="form-spacing">
                <label>Phone Number:</label>
                <input
                  required
                  size="sm"
                  v-model="form.mobileNumber"
                  placeholder="Enter Mobile Number *"
                  class="form-control"
                />
              </div>

              <label v-if="!isKuwait">Select State:</label>
              <!-- <b-form-select
                required
                size="sm"
                v-model="form.state"
                placeholder="Please Select Your State"
                :options="stateOptions()"
                class="form-control"
                @change="geCityOptions()"
              ></b-form-select> -->
              <b-form-select
                required
                size="sm"
                v-model="form.state"
                placeholder="Please Select Your State"
                :options="myStates"
                class="form-control"
                @change="handleStateChange"
                v-if="!isKuwait"
              />

              <!-- <b-form-select
                required
                size="sm"
                v-model="form.state"
                :options="stateOptions"
                class="form-control"
              ></b-form-select> -->

              <label v-if="!isKuwait">Select City:</label>
              <b-form-select
                required
                size="sm"
                placeholder="Please Select Your City"
                v-model="form.city"
                :disabled="form.state ? false : true"
                :options="cityOptions"
                class="form-control"
                v-if="!isKuwait"
              ></b-form-select>

              <!-- <b-form-select
                required
                size="sm"
                v-model="form.city"
                :options="cityOptions"
                class="form-control"
              ></b-form-select> -->
              <label v-if="isKuwait">Remarks</label>
              <b-form-textarea
                id="textarea"
                v-model="form.message"
                placeholder="Enter Remarks"
                rows="3"
                max-rows="6"
                v-if="isKuwait"
              ></b-form-textarea>

              <div
                class="w-100 pt-4 pb-3 gap-3 d-flex justify-content-start align-items-center"
                style="gap: 20px"
              >
                <button
                  type="submit"
                  class="btn rounded w-50"
                  style="background-color: #fe6d01; color: white"
                >
                  Submit
                </button>
                <b-alert
                  variant="success"
                  show
                  v-if="isSubmitted"
                  class="mb-0"
                  style="padding: 8px auto"
                  >This Form is Submitted !</b-alert
                >
              </div>
            </div>
          </form>
          <form @submit.prevent="agentHandleSubmit" v-else>
            <div class="custom-form-control">
              <div class="form-spacing">
                <label>First Name:</label>
                <input
                  size="sm"
                  required
                  v-model="agent_form.firstname"
                  placeholder="Enter First Name *"
                  class="form-control"
                />
              </div>
              <div class="form-spacing">
                <label>Last Name:</label>
                <input
                  size="sm"
                  required
                  v-model="agent_form.lastname"
                  placeholder="Enter Last Name *"
                  class="form-control"
                />
              </div>

              <div class="form-spacing">
                <label>Email:</label>
                <input
                  required
                  size="sm"
                  v-model="agent_form.email"
                  placeholder="Enter Email Address *"
                  class="form-control"
                />
              </div>

              <div class="form-spacing">
                <label>Phone Number:</label>
                <input
                  required
                  size="sm"
                  v-model="agent_form.mobile"
                  placeholder="Enter Mobile Number *"
                  class="form-control"
                />
              </div>

              <div class="form-spacing">
                <label>Password</label>
                <input
                  required
                  size="sm"
                  v-model="agent_form.password"
                  placeholder="Enter Password *"
                  class="form-control"
                />
              </div>

              <div
                class="w-100 pt-4 pb-3 gap-3 d-flex justify-content-start align-items-center"
                style="gap: 20px"
              >
                <button
                  type="submit"
                  class="btn rounded w-50"
                  style="background-color: #fe6d01; color: white"
                >
                  Submit
                </button>
                <b-alert
                  variant="success"
                  show
                  v-if="isSubmitted"
                  class="mb-0"
                  style="padding: 8px auto"
                  >This Form is Submitted !</b-alert
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>

    <section class="container-fluid px-5 my-5">
      <h2
        class="main-heading-1-gradient text-center mb-5"
        data-aos="fade-down"
        data-aos-duration="600"
      >
        Our Services
      </h2>
      <b-row class="justify-content-center align-items-center mt-5">
        <b-col v-for="card in services_arr" :key="card.id" class="text-center">
          <div v-html="card.svg" class="text-center"></div>
          <h5 class="mt-3 font-bold">{{ card.title }}</h5>
          <p>{{ card.description }}</p>
        </b-col>
      </b-row>
    </section>

    <section
      class="container-fluid px-5 pb-xl-5 mb-5 destinations-section section-spacing"
    >
      <h2
        class="main-heading-1-gradient text-center"
        data-aos="fade-down"
        data-aos-duration="600"
      >
        Explore multiple countries for your education
      </h2>
      <div class="col-lg-12 pt-xl-5 mt-3">
        <slick
          ref="destinationSlider"
          :options="destinationSlider"
          class="destination-slider arrow-slider px-lg-5"
          v-if="getCountries.length > 0"
        >
          <div
            data-aos="zoom-in"
            v-for="(country, index) in getCountries"
            :key="'country_cards_' + index"
            class="dest-card"
          >
            <div class="dest-img">
              <img
                v-if="country.country_image"
                :src="country.country_image"
                class="img-fluid"
              />
              <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
            </div>
            <div class="dest-content py-2">
              <h4 class="">Study in {{ country.country_name }}</h4>
            </div>
          </div>
          <div
            data-aos="zoom-in"
            v-for="(country, index) in getCountries"
            :key="'country_cards_' + index"
            class="dest-card"
          >
            <div class="dest-img">
              <img
                v-if="country.country_image"
                :src="country.country_image"
                class="img-fluid"
              />
              <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
            </div>
            <div class="dest-content py-2">
              <h4 class="">Study in {{ country.country_name }}</h4>
            </div>
          </div>
        </slick>
      </div>
    </section>

    <!-- Expand Your Horizons-->
    <section class="university-section section-spacing home-page">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-12 text-center"
            data-aos="fade-down"
            data-aos-duration="600"
          >
            <h2 class="main-heading-1-gradient text-center">
              Discover and choose from a variety of universities
            </h2>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <slick
              ref="logoSlider"
              :options="logoSlider"
              class="logo-slider"
              v-if="featured_universities.length > 0"
            >
              <div
                v-for="(university, index) in featured_universities"
                :key="'featured_universities_' + index"
              >
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="IMAGEURL + university[0].university_logo"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="IMAGEURL + university[1].university_logo"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="IMAGEURL + university[2].university_logo"
                      class="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </slick>
          </div>
        </div>
      </div>
    </section>

    <section class="container-fluid pb-xl-5 mb-5 responsive_padding">
      <h2
        class="main-heading-1-gradient text-center mb-5"
        data-aos="fade-down"
        data-aos-duration="600"
        ref="section"
        @scroll="handleScroll"
      >
        Why Choose Aliff {{ OfficeName }}
      </h2>
      <div class="row gradient-box bg-primary-gradient">
        <div class="col-md-6 col-lg-4 text-center mb-5">
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">{{ establishedNumber }}</div>
            </transition>
          </p>
          <!-- /*:formatValue="formatToPrice"*/ -->
          <p class="sub_heading_text">Established</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center mb-5">
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">{{ studentNumber }} K+</div>
            </transition>
          </p>
          <p class="sub_heading_text">Students Counselled</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center mb-5">
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">
                &#8377; {{ scholorshipNumber }} Crore+
              </div>
            </transition>
          </p>
          <p class="sub_heading_text">Scholarships awarded</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <!-- <img
            src="@/assets/imgs/franchise/university_4981427.png"
            class="icons_custom"
          /> -->
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">{{ universityNumber }} +</div>
            </transition>
          </p>
          <p class="sub_heading_text">Universities</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <!-- <img
            src="@/assets/imgs/franchise/bachelor_8019886.png"
            class="icons_custom"
          /> -->
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">{{ admissionNumber }} %</div>
            </transition>
          </p>
          <p class="sub_heading_text">Admission Success</p>
        </div>

        <div class="col-md-6 col-lg-4 text-center">
          <!-- <img
            src="@/assets/imgs/franchise/navigation_2763373.png"
            class="icons_custom"
          /> -->
          <p class="numbers_class">
            <transition name="fade">
              <div v-if="isVisible" class="">{{ countriesNumber }} +</div>
            </transition>
          </p>
          <p class="sub_heading_text">Countries</p>
        </div>
      </div>
    </section>

    <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">What Our Students Say</div>
            <!-- <div class="main-content-1">
              Ascend higher without the financial weight. Our customized prices
              give you the edge you need.
            </div> -->
          </div>
          <div class="col-lg-12 mt-5 stu-card-section">
            <FranchiseTestimonialSlider
              :testimonialsData="
                testimonialData['career-counselling']['testimonial-1']
              "
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import FranchiseTestimonialSlider from "@/components/partials/FranchiseTestimonial.vue";
import homeServices from "@/apiServices/homeServices";
import { mapGetters } from "vuex";
import stateCity from "../partials/stateCity";
import axios from "axios";
import { LMS_API, IMAGEURL, BASEURL } from "@/config/index";
// import { IMAGEURL } from "@/config";
import {
  // stateOptions,
  courseOptions,
  specializationOptions,
  // cityOptions,
} from "../partials/sefDetails";
export default {
  components: {
    FranchiseTestimonialSlider,
  },
  props: [
    "OfficeName",
    "OfficeNameAlternateLang",
    "OfficeAddress",
    "OfficeEmail",
    "OfficePhone",
  ],

  data() {
    return {
      IMAGEURL,
      myStates: [],
      isVisible: false,
      establishedNumber: 2008,
      studentNumber: 23,
      scholorshipNumber: 28,
      universityNumber: 450,
      admissionNumber: 100,
      countriesNumber: 19,
      num: 1000,
      count: 1000,
      establishedvalue: 2008,
      studentValue: 23,
      featured_universities: [],
      isSubmitted: false,
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },
      teamIntroSlider: {
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        // cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },

      // stateOptions,
      courseOptions,
      specializationOptions,
      cityOptions: [],
      form: {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
        message: "",
      },
      agent_form: {
        firstname: "",
        lastname: "",
        mobile: "",
        email: "",
        password: "",
        user_id: this.agent,
      },
      locationNameData: "",
      OnlyLocationName: "",
      destinationSlider: {
        infinite: true,
        rows: 2,
        slidesPerRow: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "ease",
        useTransform: true,
        speed: 1000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              dots: true,
            },
          },
        ],
      },
      services_arr: [
        {
          id: 1,
          title: "Study Abroad Counselling",
          svg: `<svg height="64px" width="64px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#FE6D01"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:#FE6D01;} </style> <g> <path class="st0" d="M463.29,305.295v-84.777h-9.38c-39.71,0-75.128,6.873-104.271,15.713c-3.467-7.023-7.264-14.182-10.956-20.92 c1.59-1.441,3.166-2.919,4.682-4.435c22.331-22.316,36.183-53.253,36.168-87.343c0.016-34.089-13.837-65.026-36.168-87.336 C321.035,13.837,290.089,0,256.007,0c-34.082,0-65.027,13.837-87.343,36.198c-22.331,22.309-36.182,53.246-36.182,87.336 c0,34.09,13.851,65.027,36.182,87.343c1.516,1.516,3.076,3.017,4.682,4.435c-3.706,6.738-7.503,13.897-10.97,20.92 c-29.159-8.84-64.547-15.713-104.257-15.713h-9.38v84.777c-28.318,0.526-39.154,23.877-39.154,52.631 c0,28.754,10.836,52.106,39.154,52.631v67.481l9.035,0.315h0.255c2.836,0.098,28.634,1.208,63.586,5.89 c34.938,4.667,79.044,12.958,118.244,27.193l1.545,0.563h29.22l1.545-0.563c40.445-14.692,86.158-23.044,121.59-27.629 c17.739-2.288,32.896-3.661,43.611-4.456c5.358-0.398,9.604-0.646,12.501-0.811c1.441-0.068,2.536-0.128,3.286-0.15 c0.36-0.023,0.646-0.038,0.811-0.038h0.27l9.049-0.315v-67.481c28.319-0.548,39.124-23.877,39.124-52.631 C502.414,329.172,491.609,305.836,463.29,305.295z M49.746,391.821c-0.315,0-0.646,0-1.006-0.015 c-6.438-0.068-20.395-1.756-20.395-33.879c0-32.131,13.957-33.819,20.395-33.88c0.36-0.022,0.691-0.022,1.006-0.022 c6.498,0,12.576,1.861,17.739,5.043c9.694,5.958,16.147,16.673,16.147,28.859c0,12.186-6.453,22.894-16.147,28.852 C62.322,389.967,56.244,391.821,49.746,391.821z M230.63,286.259v202.262c-38.089-12.126-78.069-19.15-109.974-23.314 c-23.502-3.046-42.576-4.48-53.171-5.125V407.51c20.365-7.293,34.906-26.728,34.906-49.584c0-22.856-14.542-42.299-34.906-49.584 v-68.921c48.863,1.395,90.494,13.536,120.389,25.73c15.893,6.453,28.469,12.914,36.978,17.731c2.192,1.246,4.127,2.371,5.778,3.37 V286.259z M268.884,492.708c-0.495,0.165-1.006,0.353-1.501,0.541h-22.736c-0.495-0.188-0.99-0.376-1.516-0.541V292.396h25.753 V492.708z M256.007,228.682c-28.574,0-54.402-11.353-73.341-29.812c-0.33-0.33-0.66-0.646-1.006-0.975 c-10.28-10.296-18.414-22.669-23.742-36.46c18.459-3.482,35.418-10.445,50.545-19.03c25.498-14.452,45.923-33.459,60.09-48.849 c6.123-6.649,11.061-12.629,14.723-17.296c5.898,7.602,14.797,18.752,24.942,30.315c9.11,10.378,19.21,21.086,29.235,29.978 c4.997,4.458,9.995,8.464,14.947,11.773c1.681,1.103,3.347,2.108,5.013,3.061c-4.878,17.836-14.317,33.774-27.043,46.508 c-0.346,0.33-0.675,0.668-1.021,0.998C310.379,217.352,284.552,228.682,256.007,228.682z M444.545,460.082 c-10.595,0.645-29.67,2.079-53.201,5.125c-31.875,4.142-71.856,11.188-109.944,23.314c0,0,0,0-0.014,0V286.236 c0.014,0,0.014,0,0.014,0c8.164-4.899,23.157-13.168,43.492-21.4c29.834-12.066,71.18-24.042,119.654-25.415v68.921 c-20.365,7.286-34.922,26.728-34.922,49.584c0,22.856,14.557,42.291,34.922,49.584V460.082z M463.29,391.806 c-0.375,0.015-0.705,0.015-1.02,0.015c-6.498,0-12.562-1.831-17.724-5.02c-9.695-5.98-16.178-16.688-16.178-28.874 c0-12.186,6.483-22.901,16.178-28.882c5.162-3.181,11.226-5.02,17.724-5.02c0.315,0,0.646,0,1.02,0.022 c6.453,0.083,20.38,1.794,20.38,33.88C483.669,390.012,469.743,391.723,463.29,391.806z"></path> <circle class="st0" cx="215.383" cy="161.037" r="12.502"></circle> <circle class="st0" cx="296.632" cy="161.037" r="12.502"></circle> </g> </g></svg>`,
          description: "From Admission to Placement, We Got You Covered",
        },
        {
          id: 2,
          title: "IELTS Coaching",
          svg: `<svg fill="#FE6D01" width="64px" height="64px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>books</title> <path d="M30.156 26.492l-6.211-23.184c-0.327-1.183-1.393-2.037-2.659-2.037-0.252 0-0.495 0.034-0.727 0.097l0.019-0.004-2.897 0.776c-0.325 0.094-0.609 0.236-0.86 0.42l0.008-0.005c-0.49-0.787-1.349-1.303-2.33-1.306h-2.998c-0.789 0.001-1.5 0.337-1.998 0.873l-0.002 0.002c-0.5-0.537-1.211-0.873-2-0.874h-3c-1.518 0.002-2.748 1.232-2.75 2.75v24c0.002 1.518 1.232 2.748 2.75 2.75h3c0.789-0.002 1.5-0.337 1.998-0.873l0.002-0.002c0.5 0.538 1.211 0.873 2 0.875h2.998c1.518-0.002 2.748-1.232 2.75-2.75v-16.848l4.699 17.54c0.327 1.182 1.392 2.035 2.656 2.037h0c0.001 0 0.003 0 0.005 0 0.251 0 0.494-0.034 0.725-0.098l-0.019 0.005 2.898-0.775c1.182-0.326 2.036-1.392 2.036-2.657 0-0.252-0.034-0.497-0.098-0.729l0.005 0.019zM18.415 9.708l5.31-1.423 3.753 14.007-5.311 1.422zM18.068 3.59l2.896-0.776c0.097-0.027 0.209-0.043 0.325-0.043 0.575 0 1.059 0.389 1.204 0.918l0.002 0.009 0.841 3.139-5.311 1.423-0.778-2.905v-1.055c0.153-0.347 0.449-0.607 0.812-0.708l0.009-0.002zM11.5 2.75h2.998c0.69 0.001 1.249 0.56 1.25 1.25v3.249l-5.498 0.001v-3.25c0.001-0.69 0.56-1.249 1.25-1.25h0zM8.75 23.25h-5.5v-14.5l5.5-0.001zM10.25 8.75l5.498-0.001v14.501h-5.498zM4.5 2.75h3c0.69 0.001 1.249 0.56 1.25 1.25v3.249l-5.5 0.001v-3.25c0.001-0.69 0.56-1.249 1.25-1.25h0zM7.5 29.25h-3c-0.69-0.001-1.249-0.56-1.25-1.25v-3.25h5.5v3.25c-0.001 0.69-0.56 1.249-1.25 1.25h-0zM14.498 29.25h-2.998c-0.69-0.001-1.249-0.56-1.25-1.25v-3.25h5.498v3.25c-0.001 0.69-0.56 1.249-1.25 1.25h-0zM28.58 27.826c-0.164 0.285-0.43 0.495-0.747 0.582l-0.009 0.002-2.898 0.775c-0.096 0.026-0.206 0.041-0.319 0.041-0.575 0-1.060-0.387-1.208-0.915l-0.002-0.009-0.841-3.14 5.311-1.422 0.841 3.14c0.027 0.096 0.042 0.207 0.042 0.321 0 0.23-0.063 0.446-0.173 0.63l0.003-0.006z"></path> </g></svg>`,
          description:
            "Turn your Distant Dreams to Reality by achieving the perfect band score",
        },
        {
          id: 3,
          title: "Career Counselling",
          svg: `<svg height="64px" width="64px" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#FE6D01"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> .st0{fill:#FE6D01;} </style> <g> <path class="st0" d="M463.29,305.295v-84.777h-9.38c-39.71,0-75.128,6.873-104.271,15.713c-3.467-7.023-7.264-14.182-10.956-20.92 c1.59-1.441,3.166-2.919,4.682-4.435c22.331-22.316,36.183-53.253,36.168-87.343c0.016-34.089-13.837-65.026-36.168-87.336 C321.035,13.837,290.089,0,256.007,0c-34.082,0-65.027,13.837-87.343,36.198c-22.331,22.309-36.182,53.246-36.182,87.336 c0,34.09,13.851,65.027,36.182,87.343c1.516,1.516,3.076,3.017,4.682,4.435c-3.706,6.738-7.503,13.897-10.97,20.92 c-29.159-8.84-64.547-15.713-104.257-15.713h-9.38v84.777c-28.318,0.526-39.154,23.877-39.154,52.631 c0,28.754,10.836,52.106,39.154,52.631v67.481l9.035,0.315h0.255c2.836,0.098,28.634,1.208,63.586,5.89 c34.938,4.667,79.044,12.958,118.244,27.193l1.545,0.563h29.22l1.545-0.563c40.445-14.692,86.158-23.044,121.59-27.629 c17.739-2.288,32.896-3.661,43.611-4.456c5.358-0.398,9.604-0.646,12.501-0.811c1.441-0.068,2.536-0.128,3.286-0.15 c0.36-0.023,0.646-0.038,0.811-0.038h0.27l9.049-0.315v-67.481c28.319-0.548,39.124-23.877,39.124-52.631 C502.414,329.172,491.609,305.836,463.29,305.295z M49.746,391.821c-0.315,0-0.646,0-1.006-0.015 c-6.438-0.068-20.395-1.756-20.395-33.879c0-32.131,13.957-33.819,20.395-33.88c0.36-0.022,0.691-0.022,1.006-0.022 c6.498,0,12.576,1.861,17.739,5.043c9.694,5.958,16.147,16.673,16.147,28.859c0,12.186-6.453,22.894-16.147,28.852 C62.322,389.967,56.244,391.821,49.746,391.821z M230.63,286.259v202.262c-38.089-12.126-78.069-19.15-109.974-23.314 c-23.502-3.046-42.576-4.48-53.171-5.125V407.51c20.365-7.293,34.906-26.728,34.906-49.584c0-22.856-14.542-42.299-34.906-49.584 v-68.921c48.863,1.395,90.494,13.536,120.389,25.73c15.893,6.453,28.469,12.914,36.978,17.731c2.192,1.246,4.127,2.371,5.778,3.37 V286.259z M268.884,492.708c-0.495,0.165-1.006,0.353-1.501,0.541h-22.736c-0.495-0.188-0.99-0.376-1.516-0.541V292.396h25.753 V492.708z M256.007,228.682c-28.574,0-54.402-11.353-73.341-29.812c-0.33-0.33-0.66-0.646-1.006-0.975 c-10.28-10.296-18.414-22.669-23.742-36.46c18.459-3.482,35.418-10.445,50.545-19.03c25.498-14.452,45.923-33.459,60.09-48.849 c6.123-6.649,11.061-12.629,14.723-17.296c5.898,7.602,14.797,18.752,24.942,30.315c9.11,10.378,19.21,21.086,29.235,29.978 c4.997,4.458,9.995,8.464,14.947,11.773c1.681,1.103,3.347,2.108,5.013,3.061c-4.878,17.836-14.317,33.774-27.043,46.508 c-0.346,0.33-0.675,0.668-1.021,0.998C310.379,217.352,284.552,228.682,256.007,228.682z M444.545,460.082 c-10.595,0.645-29.67,2.079-53.201,5.125c-31.875,4.142-71.856,11.188-109.944,23.314c0,0,0,0-0.014,0V286.236 c0.014,0,0.014,0,0.014,0c8.164-4.899,23.157-13.168,43.492-21.4c29.834-12.066,71.18-24.042,119.654-25.415v68.921 c-20.365,7.286-34.922,26.728-34.922,49.584c0,22.856,14.557,42.291,34.922,49.584V460.082z M463.29,391.806 c-0.375,0.015-0.705,0.015-1.02,0.015c-6.498,0-12.562-1.831-17.724-5.02c-9.695-5.98-16.178-16.688-16.178-28.874 c0-12.186,6.483-22.901,16.178-28.882c5.162-3.181,11.226-5.02,17.724-5.02c0.315,0,0.646,0,1.02,0.022 c6.453,0.083,20.38,1.794,20.38,33.88C483.669,390.012,469.743,391.723,463.29,391.806z"></path> <circle class="st0" cx="215.383" cy="161.037" r="12.502"></circle> <circle class="st0" cx="296.632" cy="161.037" r="12.502"></circle> </g> </g></svg>`,
          description:
            "Make Your Career Dreams a Reality with Our Expert Guidance",
        },
        {
          id: 4,
          title: "Aliff Premium Packages",
          svg: `<svg width="64px" height="64px" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M21.2501 3C21.4925 3 21.7176 3.11688 21.8574 3.30983L21.9119 3.39706L25.9186 10.9098L25.9615 11.0122L25.9731 11.05L25.9901 11.1273L25.9994 11.2153L25.9973 11.3147L26.0001 11.25C26.0001 11.3551 25.9785 11.4552 25.9394 11.5461L25.9106 11.6057L25.87 11.6723L25.8173 11.7408L14.6 24.7047C14.4999 24.8391 14.3628 24.9277 14.2139 24.9703L14.1559 24.9844L14.0585 24.9979L13.9999 25L13.8993 24.9932L13.8142 24.9771L13.7109 24.9432L13.6852 24.931C13.5949 24.8911 13.5119 24.8316 13.4425 24.7535L2.17081 11.7263L2.1087 11.6387L2.06079 11.5456L2.02611 11.4463L2.00297 11.3152L2.00269 11.1878L2.01755 11.0891L2.02714 11.0499L2.06104 10.9538L2.08838 10.8971L6.08838 3.39706C6.20243 3.18321 6.41149 3.0396 6.64753 3.00704L6.75014 3H21.2501ZM17.9061 12H10.0911L14.0011 22.16L17.9061 12ZM8.48514 12H4.38914L11.7621 20.518L8.48514 12ZM23.6081 12H19.5151L16.2421 20.511L23.6081 12ZM10.0241 4.499H7.19914L3.99814 10.5H8.42314L10.0241 4.499ZM16.4231 4.499H11.5761L9.97514 10.5H18.0231L16.4231 4.499ZM20.8001 4.499H17.9751L19.5761 10.5H23.9991L20.8001 4.499Z" fill="#FE6D01"></path> </g></svg>`,
          description: "From Admission to Placement, We Got You Covered",
        },
      ],
    };
  },
  props: {
    testimonialsData: {
      type: Array,
      default: "",
    },
    OfficeName: String,
    OfficeNameAlternateLang: String,
    OfficeAddress: String,
    OfficeEmail: String,
    OfficePhone: String,
    source: {
      type: Number,
      default: 0,
    },
    agent: {
      type: Number,
      default: 0,
    },
    isKuwait: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    let locationName = window.location.href.split("/");
    this.locationNameData = locationName;
    this.OnlyLocationName = this.locationNameData[3].split("-");
    // console.log(locationName, "locationName");
    // console.log(this.OnlyLocationName[0].toUpperCase(), "OnlyLocationName");

    this.getData();
    this.getMyStates();
  },
  computed: {
    ...mapGetters(["getCountries"]),
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    // this.setCount(this.num);
  },
  methods: {
    stateOptions() {
      return stateCity.map((stateCity) => stateCity.state);
    },
    async getMyStates() {
      try {
        const res = await axios.get(LMS_API + "/form-webhook/master/states");
        this.myStates = res.data.data.map((state) => ({
          value: state.state_id,
          text: state.name,
        }));
        console.log(this.myStates);
      } catch (error) {
        console.log(error);
      }
    },
    async handleStateChange() {
      console.log("Selected State:", this.form.state);
      try {
        // Make an API call to fetch cities based on the selected state_id
        const response = await axios.get(
          LMS_API + `/form-webhook/master/cities/${this.form.state}`
        );
        this.cityOptions = response.data.data.map((city) => ({
          value: city.city_id,
          text: city.name,
        }));
        console.log("Fetched Cities:", this.cityOptions);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    geCityOptions() {
      let currentStateCity = stateCity.find(
        (stateCity) => stateCity.state === this.form.state
      );

      this.cityOptions = currentStateCity.cities;
    },
    handleScroll() {
      const sectionPosition = this.$refs.section.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;

      if (sectionPosition < windowHeight * 0.75) {
        // If the section is 75% visible
        this.isVisible = true;
        this.startAnimation();
        window.removeEventListener("scroll", this.handleScroll);
      }
    },
    startAnimation() {
      let count = 1900;

      let estinterval = setInterval(() => {
        count++;

        this.establishedNumber = count;

        if (count === 2008) {
          clearInterval(estinterval);
        }
      }, 20);

      let studentCount = 2;
      let studentinterval = setInterval(() => {
        studentCount++;

        this.studentNumber = studentCount;
        if (studentCount === 23) {
          clearInterval(studentinterval);
        }
      }, 20);

      let ScholarshipsCount = 2;
      let Scholarshipsinterval = setInterval(() => {
        ScholarshipsCount++;

        this.scholorshipNumber = ScholarshipsCount;
        if (ScholarshipsCount === 28) {
          clearInterval(Scholarshipsinterval);
        }
      }, 20);

      let universityCount = 400;
      let universitysinterval = setInterval(() => {
        universityCount++;

        this.universityNumber = universityCount;
        if (universityCount === 450) {
          clearInterval(universitysinterval);
        }
      }, 20);

      let admissionCount = 70;
      let admissioninterval = setInterval(() => {
        admissionCount++;

        this.admissionNumber = admissionCount;
        if (admissionCount === 100) {
          clearInterval(admissioninterval);
        }
      }, 20);

      let countriesCount = 0;
      let countriesinterval = setInterval(() => {
        countriesCount++;

        this.countriesNumber = countriesCount;
        if (countriesCount === 19) {
          clearInterval(countriesinterval);
        }
      }, 20);
    },
    formSubmitToast() {
      // this.$bvToast.toast(`The form has been submitted successfully.`, {
      //   title: "Form Submitted",
      //   autoHideDelay: 5000,
      //   solid: true,
      // });
      this.isSubmitted = true;
    },

    async handleSubmit(e) {
      try {
        e.preventDefault();
        const requestData = {
          // name: this.form.name,
          full_name: this.form.name,
          email: this.form.email,
          dial_code_id: "12183",
          country_dial_code: "+91",
          mobile: this.form.mobileNumber,
          // source: "associate-enquiry-form",
          source: this.OnlyLocationName[0] + "-" + "enquiry-form",
          message: this.form.message,
          state: this.form.state,
          city: this.form.city,
          ls_id: this.source,
          // m_id: 1,
          // c_id:1,
          category: "Student",
        };

        const response = await axios.post(
          `${LMS_API}/form-webhook/lead`,
          requestData
        );
        if (response.data.status) {
          this.resetForm();
          this.formSubmitToast();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    async agentHandleSubmit(e) {
      try {
        e.preventDefault();
        console.log(this.agent_form);
        const response = await axios.post(
          `${BASEURL}/webhook/add-student-micro`,
          this.agent_form
        );
        if (response.data.status) {
          this.resetAgentForm();
          this.formSubmitToast();
        }
      } catch (error) {
        console.error("Error submitting form:", error);
      }
    },

    resetForm() {
      this.form = {
        name: "",
        email: "",
        mobileNumber: "",
        state: null,
        city: null,
      };
    },
    resetAgentForm() {
      this.agent_form = {
        firstname: "",
        lastname: "",
        mobile: "",
        email: "",
        password: "",
        user_id: this.agent,
      };
    },
    async getData() {
      try {
        const featured_universities =
          await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    },
  },
};
</script>
<style>
.alert {
  padding: 0.4rem 1.25rem !important;
}

.franchise-wrapper {
  margin-top: 120px;
}

.form_wrapper {
  background-color: #fff;
  padding: 20px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.fontWeightCustom {
  font-weight: 500;
}

.horizontal_line {
  width: 100%;
}

.city_img {
  position: absolute;
  top: 190px;
  right: 20px;
  z-index: -1;
  opacity: 0.2;
}

.city_img img {
  width: 90%;
}

.numbers_class {
  font-size: 50px !important;
  font-weight: bold;
}

.sub_heading_text {
  font-size: 30px;
}

.icons_custom {
  width: 25%;
  filter: drop-shadow(0 0 0.75rem black);
  margin-bottom: 10px;
}

.director_background {
  position: absolute;
  right: 0;
  top: 100px;
  opacity: 0.2;
  z-index: -1;
}

.custom_director_section {
  padding: 40px;
  background: #eaf4fe;
  border-radius: 10px;
  box-shadow: 0px 0px 0.806476px rgba(12, 26, 75, 0.1),
    3.22591px 4.83886px 12.9036px rgba(20, 37, 63, 0.12);
}

.responsive_padding {
  padding: 0 3rem;
}

.new_sub_heading_color {
  color: #ff3d00 !important;
}

@media (max-width: 767px) {
  .responsive_margin {
    margin-top: 10px;
  }

  .responsive_margin_area {
    margin-top: 30px;
  }

  .main_btn_custom {
    width: 100%;
    transform: scale(1) !important;
  }

  .director_background {
    position: absolute;
    top: 15px;
    opacity: 0.1;
    z-index: -1;
    widows: 100%;
    right: -133px;
  }

  .responsive_padding {
    padding: 0px;
  }

  .custom_overflow {
    overflow: hidden;
  }

  .city_img {
    position: absolute;
    top: 44%;
    right: -30%;
    z-index: -1;
    opacity: 0.2;
    /* width: 100%; */
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .custom_overflow {
    overflow: hidden;
  }

  .responsive_margin {
    margin-top: 10px;
  }

  .city_img {
    position: absolute;
    top: -15%;
    right: -30%;
    opacity: 0.2;
    width: 100%;
  }

  .director_background {
    position: absolute;
    right: 0;
    top: 0px;
    opacity: 0.1;
  }

  .icons_custom {
    width: 40%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/partials/FranchiseCommanData.vue